export const SUPPLIER_LOGOS = {
  brilliantCreations: "/suppliers/Brilliant Creations.webp",
  cePublishing: "/suppliers/CE-Logo.webp",
  diwa: "/suppliers/Diwa.webp",
  iciPhilippines: "/suppliers/ICI Publishing.webp",
  joes: "/suppliers/JOES publishing house.webp",
  rexEducation:
    "/suppliers/_REX_Book_Store-REX_Education_logo_from_2021.png_.webp",
  sibsPublishing: "/suppliers/Sibs publishing.webp",
  tahanan: "/suppliers/Tahanan.webp",
  totalLanguagePlus: "/suppliers/Total Language Plus.webp",
  masterBooks: "/suppliers/Masterbooks.webp",
  apologia: "/suppliers/apologia_educational_ministries_logo.webp",
  aop: "/suppliers/Lifepac-AOP Logo.webp",
  bjuPress: "/suppliers/BJU PRESS LOGO.webp",
  brightIdeasPress: "/suppliers/Bright Ideas Press.webp",
  classicalConversations: "/suppliers/Classical Conversations.webp",
  anvilPublishing: "/suppliers/anvil publishing.webp",
  kidstarter: "/suppliers/kidstarter.webp",
  livingBooks: "/suppliers/living book press.webp",
  sscMardison: "/suppliers/ssc mardison.webp",
  starPublishing: "/suppliers/star publishing.webp",
  tyndale: "/suppliers/tyndale.webp",
  omfLit: "/suppliers/omf lit.webp"
} as const;
